<div
	class="form-step-fields__preset-grid"
	[class.form-step-fields__preset-grid--composite]="hasCompositeGrid"
	[class.grid]="!hasCompositeGrid"
	[class.grid-i2]="!hasCompositeGrid"
>
	@for (fieldDef of preset.presetFields!; track fieldDef.fieldId) {
		<div
			class="form-step-fields__preset-cell"
			[class.form-step-fields__preset-cell--full]="fieldDef.gridSpan === 'full'"
			[class.form-step-fields__preset-cell--half]="fieldDef.gridSpan === 'half'"
			[class.form-step-fields__preset-cell--third]="fieldDef.gridSpan === 'third'"
		>
			<tec-item
				[title]="resolveFieldTitle(fieldDef, $index)"
				[disabled]="true"
				[clickeable]="false"
			>
				<tec-list-detail>
					<tec-info-group>
						<span>{{ fieldDef.typeLabelKey | translate }}</span>
					</tec-info-group>
				</tec-list-detail>
			</tec-item>
		</div>
	}
</div>
